import CurrentApplicationDetailsInfo from './details'
import ApplicationDetailsLogo from './logo'
import CurrentApplicationInfo from './info'

import './styles.scss'

export default function ApplicationDetails() {
  return (
    <div className='application-details'>
      <ApplicationDetailsLogo />
      <CurrentApplicationDetailsInfo />
      <CurrentApplicationInfo />
    </div>
  )
}
